import { RawMaterialMasterThemeSizeConfig } from './types';

const medium: RawMaterialMasterThemeSizeConfig = {
  rawMaterialMaster: {},
};

export default medium;
